import React from 'react';

interface ButtonGroupProps {
  options: { label: string; value: string | number }[];
  value: string | number;
  onChange: (value: string | number) => void;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ options, value, onChange }) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px', border: '1px solid #334155', borderRadius: '0.375rem', padding: '2px' }}>
      {options.map((option) => {
        const isActive = value === option.value;
        return (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            style={{
              padding: '0.375rem 0.625rem',
              fontSize: '0.75rem',
              color: isActive ? '#f1f5f9' : '#94a3b8',
              backgroundColor: isActive ? '#4f46e5' : 'transparent',
              border: 'none',
              borderRadius: '0.25rem',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default ButtonGroup; 